module.exports = __webpack_public_path__ + "static/media/tcon.17126620.png";